import React, { Component } from 'react';
import Calendar from './Calendar';
import Dropdown from './Dropdown';
import Checkbox from './Checkbox';
import {roomsOptions} from '../config/options';
import {personsOptions} from '../config/options';
import {reasonOptions} from '../config/options';

class MobileFilter extends Component {

    constructor(){
        super();

        this.state = {
            showFilter:false
        }

        this.handlePersonsSelection = this.handlePersonsSelection.bind(this);
        this.handleReasonSelection = this.handleReasonSelection.bind(this);
        this.handleBreakfastSelection = this.handleBreakfastSelection.bind(this);
        this.handleDoublebedSelection = this.handleDoublebedSelection.bind(this);
        this.handleKitchenSelection = this.handleKitchenSelection.bind(this);
        this.handlePlaceforkidsSelection = this.handlePlaceforkidsSelection.bind(this);
        this.handlePetsallowedSelection = this.handlePetsallowedSelection.bind(this);
        this.showFilter = this.showFilter.bind(this);
        this.searchData = this.searchData.bind(this);
    }

    handlePersonsSelection(persons){
        this.props.onSelectPersons(persons);
    }

    handleReasonSelection(reason){
        this.props.onSelectReason(reason);
    }

    handleBreakfastSelection(event){
        this.props.onCheckBreakfast(event.target.checked);
    }

    handleDoublebedSelection(event){
        this.props.onCheckDoublebed(event.target.checked);
    }

    handleKitchenSelection(event){
        this.props.onCheckKitchen(event.target.checked);
    }

    handlePlaceforkidsSelection(event){
        this.props.onCheckPlaceforkids(event.target.checked);
    }

    handlePetsallowedSelection(event){
        this.props.onCheckPetsallowed(event.target.checked);
    }

    showFilter(){
        this.setState({
            showFilter: !this.state.showFilter
        })
    }

    searchData(){
        this.showFilter();
        this.props.onSearchData();
    }
    
    render(){
        if(this.props.visible){
            return(
                <div className="mobile-filter">
                    <h4 onClick={this.showFilter}>filter <span className={this.state.showFilter ? 'open' : 'closed'}></span></h4>
                    <div className="filter-toggle" style={{'display':this.state.showFilter ? 'block' : 'none'}}>
                    <div className="vb-checkin-box">
                        <label>Check in</label>
                        <Calendar value={this.props.dateInterval} onSelect={this.props.onDateSelect} numberOfCalendars={1}/>
                    </div>
                    <label>Rooms</label>
                    <Dropdown
                                    value={this.props.roomsNumber}
                                    options={roomsOptions}
                                    placeholder='All rooms'
                                    onChange={this.props.onRoomsChange}
                                    className='vb-select-rooms'
                                    name="rooms"
                    />

                    <label>Code</label>
                    <div className="vb-code">
                        <input type="text" value={this.props.code} onChange={this.props.onCodeChange} placeholder="enter code"/>
                    </div>

                    <label>Persons</label>
                    <Dropdown
                                    value={this.props.selectedPersons}
                                    options={personsOptions}
                                    onChange={this.handlePersonsSelection}
                                    placeholder={this.props.selectedPersons ? this.props.selectedPersons : 1}
                                    className='vb-select-rooms'
                                    name="persons"
                    />

                    <label>Trip reason</label>
                    <Dropdown
                                    value={this.props.selectedReason}
                                    options={reasonOptions}
                                    onChange={this.handleReasonSelection}
                                    placeholder='choose'
                                    className='vb-select-rooms'
                                    name="reason"
                    />

                    <div className="vb-checkbox">
                        <Checkbox value="1" checked={this.props.breakfast} onChange={this.handleBreakfastSelection}/>                                    
                        <p>Breakfast included</p>
                    </div>

                    <div className="vb-checkbox">
                        <Checkbox value="1" checked={this.props.doublebed} onChange={this.handleDoublebedSelection}/>
                        <p>One double bed</p>
                    </div>

                    <div className="vb-checkbox">
                        <Checkbox value="1" checked={this.props.kitchen} onChange={this.handleKitchenSelection}/>
                        <p>With kitchen</p>
                    </div>

                    <div className="vb-checkbox">
                        <Checkbox value="1" checked={this.props.placeforkids} onChange={this.handlePlaceforkidsSelection}/>
                        <p>Place for kids</p>
                    </div>

                    <div className="vb-checkbox">
                        <Checkbox value="1" checked={this.props.petsallowed} onChange={this.handlePetsallowedSelection}/>
                        <p>With pets</p>
                    </div>

                    <button className="vb-search-button" onClick={this.searchData}>
                        <span>Apply Filter</span>
                        <i></i>
                    </button>
                    </div>
                </div>
            )
        }else{
            return false;
        } 
    }
}

export default MobileFilter;